import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

import Input from '../../../../../components/input/input';

import './styles.scss';

export enum BacktestTabModalView {
  NEW,
  RENAME,
  DUPLICATE,
  DELETE,
}

const TITLES = {
  [BacktestTabModalView.NEW]: 'New study',
  [BacktestTabModalView.RENAME]: 'Rename study',
  [BacktestTabModalView.DUPLICATE]: 'Duplicate study',
  [BacktestTabModalView.DELETE]: 'Are you sure you want to delete this study?',
};

interface HandleBacktestTabModalProps {
  open: boolean;
  view: BacktestTabModalView;
  handleClose: () => void;
  onSave: (name: string) => void;
  onRename: (name: string) => void;
  onDuplicate: (name: string) => void;
  onDelete: () => void;
}

export const HandleBacktestTabModal = ({
  open,
  view,
  handleClose,
  onSave,
  onRename,
  onDuplicate,
  onDelete,
}: HandleBacktestTabModalProps) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (open) setName('');
  }, [open, view]);

  const handleAction = () => {
    handleClose();
    switch (view) {
      case BacktestTabModalView.NEW:
        onSave(name);
        break;
      case BacktestTabModalView.RENAME:
        onRename(name);
        break;
      case BacktestTabModalView.DUPLICATE:
        onDuplicate(name);
        break;
      case BacktestTabModalView.DELETE:
        onDelete();
        break;
    }
  };

  const renderBody = useMemo(() => {
    if (view === BacktestTabModalView.DELETE) {
      return (
        <div className="items">
          <div className="message">
            This saved study will be permanently removed from your library.
          </div>
        </div>
      );
    }

    return (
      <div className="items">
        <div className="item">
          <Input
            placeholder="Study name"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
          />
        </div>
      </div>
    );
  }, [view, name]);

  const renderButtons = () => {
    if (view === BacktestTabModalView.DELETE) {
      return (
        <div className="buttons">
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="delete-button" onClick={handleAction}>
            Delete anyway
          </Button>
        </div>
      );
    }

    return (
      <div className="buttons">
        <Button className="add-button" onClick={handleAction} disabled={!name.trim()}>
          Save
        </Button>
      </div>
    );
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="backtest-tab-modal-container">
        <div className="backtest-tab-modal-content">
          <div className="header">
            <h1>{TITLES[view]}</h1>
            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>
          {renderBody}
          {renderButtons()}
        </div>
      </div>
    </Modal>
  );
};
